//import React from "react";
import { useTranslation } from 'react-i18next';

type PricingPlan = {
  title: string;
  price: string;
  dayprice: string;
  duration: string;
  features: string[];
  length: number;
};

const Pricingcard = () => {
  const { t } = useTranslation();
const pricingPlans = t('pricing.plans', { returnObjects: true }) as PricingPlan[];

  const handleChatClick = () => {
    // Option 1: Direct link approach (like your PHP version)
    window.open('https://tawk.to/chat/67d46ba7a02871190e077aed/1imas936e', '_blank');
    
    // Option 2: Programmatic API approach (if you want to use the embedded widget)
    // if (window.Tawk_API) {
    //   window.Tawk_API.maximize();
    // } else {
    //   window.open('https://tawk.to/chat/67d46ba7a02871190e077aed/default', '_blank');
    // }
  };

  return (
    <section id="pricing" className="md:container py-10 bg-white-bg min-h-[70%] text-center items-center justify-center">
      <h1 className="text-5xl truncate text-black font-primary font-bold ">
        {t('pricing.title')}
      </h1>
      <div className="pricing-wrapper text-wrap grid grid-cols-1 md:grid-cols-3 gap-4">
        {pricingPlans.map((plan, index) => (
          <div key={index} className="font-secondary rounded-2xl p-5 mb-3 bg-slate-800 shadow">
            <div className="max-w-[320px] px-5 py-10">
              <p className="text-center text-2xl font-bold text-white">{plan.title}</p>

              <h2 className="mt-4 text-center text-sm font-normal">
                <span className="text-lg">
                  {t('pricing.spendPerDay')} 
                  <span className="font-bold text-yellow-500"> {plan.dayprice} </span> 
                  {t('pricing.perDay')}
                </span>
              </h2>

              <div className="mt-5 flex justify-center text-white">
                <div className="text-6xl font-medium text-yellow-500">{plan.price}</div>
                <div className="ml-2 flex flex-col">
                  <p className="text-lg font-bold">{t('pricing.for')}</p>
                  <p>{plan.duration}</p>
                </div>
              </div>

              <div className="mt-5">
                <ul className="mt-6 space-y-6 text-white">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-center">
                      <svg
                        className={`mr-3 h-4 w-4 fill-current ${index < plan.length ? 'text-green-400' : 'text-gray-800'}`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z" />
                      </svg>
                      <span className="ml-2">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-5 text-white text-center">
                <p className="text-lg font-bold">
                  {t('pricing.upgradeText')} 
                  <span className="text-yellow-500 text-2xl">₹599</span> 
                  {t('pricing.upgradeText2')}
                </p>
                <p className="text-sm text-gray-300">{t('pricing.upgradeNote')}</p>
              </div>
              
              <div className="mt-8">
        <button 
          className="boton-elegante mt-4"
          onClick={handleChatClick}
        >
          {t('pricing.cta')}
        </button>

              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Pricingcard;